import { render } from "./UsersPage.vue?vue&type=template&id=12183f08&scoped=true&ts=true"
import script from "./UsersPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UsersPage.vue?vue&type=script&lang=ts&setup=true"

import "./UsersPage.vue?vue&type=style&index=0&id=12183f08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12183f08"],['__file',"src/pages/users/UsersPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12183f08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12183f08', __exports__)) {
    api.reload('12183f08', __exports__)
  }
  
  module.hot.accept("./UsersPage.vue?vue&type=template&id=12183f08&scoped=true&ts=true", () => {
    api.rerender('12183f08', render)
  })

}


export default __exports__